(function() {
  var VARIANT_ID = 58628975362429;

  function getAbilitazioneQty() {
    var qty = 0;
    document.querySelectorAll('.variant-item').forEach(function(el) {
      if (el.textContent.includes('Abilitazione')) {
        var qtyEl = el.querySelector('input[type="number"]');
        if (qtyEl) qty = parseInt(qtyEl.value) || 0;
      }
    });
    return qty;
  }

  function getChipCodes() {
    var codes = [];
    var qty = getAbilitazioneQty();
    for (var i = 1; i <= qty; i++) {
      var input = document.getElementById('chip-code-' + i);
      codes.push(input ? input.value.trim() : '');
    }
    return codes;
  }

  function showError(index, message) {
    var input = document.getElementById('chip-code-' + (index + 1));
    if (input) {
      input.style.border = '2px solid red';
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      input.focus();
      setTimeout(function() { input.style.border = '1px solid #ccc'; }, 3000);
    }
    var err = document.getElementById('chip-code-error-' + (index + 1));
    if (err) {
      err.textContent = message || '⚠️ Inserisci un codice chip valido di 7 cifre numeriche.';
      err.style.display = 'block';
      setTimeout(function() { err.style.display = 'none'; }, 3000);
    }
  }

  function isValid() {
    var qty = getAbilitazioneQty();
    if (qty === 0) return true;
    var codes = getChipCodes();
    var seen = [];
    var valid = true;
    for (var i = 0; i < codes.length; i++) {
      if (!/^[0-9]{7}$/.test(codes[i])) {
        showError(i, '⚠️ Inserisci un codice chip valido di 7 cifre numeriche.');
        valid = false;
        break;
      }
      if (seen.indexOf(codes[i]) !== -1) {
        showError(i, '⚠️ Questo codice chip è già stato inserito.');
        valid = false;
        break;
      }
      seen.push(codes[i]);
    }
    return valid;
  }

  function attachChipProperties() {
    var codes = getChipCodes();
    if (codes.length === 0) return Promise.resolve();

    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var item = cart.items.find(function(i) { return i.variant_id === VARIANT_ID; });
        if (!item) return;

        var properties = {};
        codes.forEach(function(code, idx) {
          if (code) properties['Codice Chip ' + (idx + 1)] = code;
        });

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: properties
          })
        });
      })
      .then(function(r) { if (r) return r.json(); })
      .catch(function(e) { console.error('Errore chip:', e); });
  }

  // Intercetta /cart/update
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    var result = originalFetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('/cart/update') && getAbilitazioneQty() > 0) {
      result.then(function() {
        setTimeout(attachChipProperties, 1000);
      });
    }
    return result;
  };

  // Intercetta click su carrello/checkout
  document.addEventListener('click', function(e) {
    var el = e.target.closest('a[href*="/cart"], a[href*="/checkout"], [href="/cart"], .cart-link');
    if (!el) return;

    if (!isValid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }

    if (getAbilitazioneQty() > 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      attachChipProperties().then(function() {
        window.location.href = el.href;
      });
    }
  }, true);

  // Intercetta submit form
  document.addEventListener('submit', function(e) {
    if (!isValid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  function buildFields(qty) {
    var html = '';
    for (var i = 1; i <= qty; i++) {
      html += '<label for="chip-code-' + i + '" style="display:block;margin-bottom:4px;font-weight:600;font-size:14px;">Codice Chip ' + i + ' * (7 cifre)</label>';
      html += '<input id="chip-code-' + i + '" type="text" inputmode="numeric" pattern="[0-9]{7}" maxlength="7" placeholder="Es. 1234567" oninput="this.value=this.value.replace(/[^0-9]/g,\'\')" style="width:100%;min-width:200px;padding:8px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;margin-bottom:4px;">';
      html += '<p id="chip-code-error-' + i + '" style="display:none;color:red;font-size:13px;margin-bottom:8px;">⚠️ Inserisci un codice chip valido di 7 cifre numeriche.</p>';
    }
    return html;
  }

  function injectField() {
    var qty = getAbilitazioneQty();
    var field = document.getElementById('chip-code-field');

    if (qty === 0) {
      if (field) field.style.display = 'none';
      return;
    }

    var targetContainer = null;
    document.querySelectorAll('.variant-item').forEach(function(el) {
      if (el.textContent.includes('Abilitazione')) {
        targetContainer = el;
      }
    });
    if (!targetContainer) return;

    if (!field) {
      field = document.createElement('div');
      field.id = 'chip-code-field';
      field.style.cssText = 'margin:8px 0; width:100%; clear:both; grid-column: 1 / -1;';
      targetContainer.appendChild(field);
    }

    var currentQty = field.querySelectorAll('input').length;
    if (currentQty !== qty) {
      field.innerHTML = buildFields(qty);
    }

    field.style.display = 'block';
  }

  setInterval(injectField, 300);
  injectField();
})();
